import React, { useEffect, useState } from "react"
import { useLifecycles } from "react-use"
import { CSSTransition } from "react-transition-group"
import { useForm } from "react-hook-form"
import { currencyFormatWithSign } from "scripts/utils/currencyFormat"
import { initDatepicker_cert } from "scripts/components/datepicker-cert"
import { Input, InputDate, InputTime } from "../checkout2/ui/input"
import CommunicationMethod from "../ui/CommunicationMethod"
import { Checkbox } from "../checkout2/ui/checkbox"
import { validationRules } from "../checkout2/constants"
import OrderComment from "./OrderComment"
import Modal from "../Modal"
import { certificates } from "../api"
import { initDatepickerCalendar } from "scripts/components/profile"

function ModalContentBlock({ title, subtitle, children, className = "", ...restProps }) {
  return (
    <div className="modal-content-block">
      <div>
        {title && <h2 className="modal-content-block__title body-b-16">{title}</h2>}
        {subtitle && <p className="modal-content-block__subtitle">{subtitle}</p>}
      </div>
      {children}
    </div>
  )
}

function getDateWithOffset(dayOffset = 0) {
  const date = new Date()
  date.setDate(date.getDate() + dayOffset)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  const dateString = `${year}-${month}-${day}`
  return dateString
}

const { user = {} } = window

export default function ModalCertificateOrder({ toOrderValue }) {
  const [isSelfOpen, setIsSelfOpen] = useState(true)
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    trigger,
    clearErrors,
    getValues,
    formState: { errors, isSubmitting, defaultValues },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      price: toOrderValue,
      name: user.name || "",
      last_name: user.last_name || "",
      phone: user.phone || "",
      email: user.email || "",
      delivery: "viber",
      another_recipient: false,
      recipient_name: "",
      recipient_last_name: "",
      recipient_phone: "",
      recipient_email: "",
      delivery_date: "",
      delivery_date_only: getDateWithOffset(1),
      delivery_time: "12:00",
      // delivery_message: "",
      payment: "liqpay",
      comment: "",
      term_of_use_confirm: true,
    },
  })

  const anotherRecipient = watch("another_recipient")

  useEffect(() => {
    if (anotherRecipient) {
      clearErrors("recipient_name")
      clearErrors("recipient_last_name")
      clearErrors("recipient_phone")
      clearErrors("recipient_email")

      window.customSelect.update(".ui-datepicker-month")
      window.customSelect.update(".ui-datepicker-year")
      // window.customSelect.update(".js_select_time_hour")
      initDatepickerCalendar(initDatepicker_cert.bind(undefined,{
          yearRange: `c:+1`,
          dateFormat: "dd.mm.yy",
          defaultDate: +1,
          maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
          minDate: new Date(),
        })
      )
    }
    window.maskedInput()
  }, [anotherRecipient, clearErrors])

  useLifecycles(() => {
    document.documentElement.classList.add("overflow")
  })

  const handleModalClose = (e) => {
    e.stopPropagation()
    if (!e.target.closest(".modal-content") || e.target.classList.contains("js-close")) {
      e.stopPropagation()
      setIsConfirmModalOpen(true)
    }
  }

  const onSubmit = (data) => {
    const payload = {
      ...data,
    }
    payload["phone"] = payload["phone"].replace(/\D/g, "")
    payload["recipient_phone"] = payload["recipient_phone"].replace(/\D/g, "")

    delete payload["term_of_use_confirm"]
    if (!payload["another_recipient"]) {
      delete payload["recipient_name"]
      delete payload["recipient_last_name"]
      delete payload["recipient_phone"]
      delete payload["recipient_email"]
      delete payload["delivery_date"]
      delete payload["delivery_message"]
    } else {
      payload[
        "delivery_date"
      ] = `${payload["delivery_date_only"]} ${payload["delivery_time"]}:00`
    }

    delete payload["delivery_time"]
    delete payload["delivery_date_only"]
    delete payload["delivery_time_hour"]
    delete payload["delivery_time_minute"]

    try {
      certificates(payload).then((res) => {
        window.location.href = res.data.payment_url
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <CSSTransition
        in={isSelfOpen}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
        onExit={() => {
          document.documentElement.classList.remove("overflow")
        }}
      >
        <>
          <div
            className={`modal modal-medium modal--dbl-leaf modal-certificate-order`}
            data-target="modal-certificate-order"
            style={{ display: "block" }}
            onClick={handleModalClose}
          >
            <div className="modal__zoom">
              <div className="modal-content modal-contect--narrow">
                <div className="flex">
                  <div className="modal-l-side">
                    <div className="close-btn js-close" onClick={handleModalClose} />
                    <div className="modal__content">
                      <div className="modal__title">
                        {window.labels.e_certificate.title}
                      </div>
                      <div className="modal__content-body scrolling-block">
                        <form onSubmit={handleSubmit(onSubmit)} id="cer_order_form">
                          <ModalContentBlock
                            title={window.labels.e_certificate.personal_data.title}
                            subtitle={window.labels.e_certificate.personal_data.subtitle}
                          >
                            <div className="form-label-list">
                              <Input
                                title={window.labels.checkout.fields.name}
                                type="text"
                                error={
                                  window.labels.checkout.errors["name"]?.[
                                    errors["name"]?.type
                                  ]
                                }
                                focus={Boolean(defaultValues.name)}
                                isError={Boolean(errors["name"])}
                                {...register("name", {
                                  ...validationRules["default"],
                                  setValueAs: (value) => value.trim(),
                                })}
                              />

                              <Input
                                title={window.labels.checkout.fields.surname}
                                type="text"
                                error={
                                  window.labels.checkout.errors["surname"]?.[
                                    errors["last_name"]?.type
                                  ]
                                }
                                focus={Boolean(defaultValues.last_name)}
                                isError={Boolean(errors["last_name"])}
                                {...register("last_name", {
                                  ...validationRules["default"],
                                  setValueAs: (value) => value.trim(),
                                })}
                              />
                              <Input
                                title={window.labels.checkout.fields.phone}
                                type="tel"
                                isError={Boolean(errors["phone"])}
                                error={
                                  window.labels.checkout.errors["phone"]?.[
                                    errors["phone"]?.type
                                  ]
                                }
                                {...register("phone", {
                                  ...validationRules["phone"],
                                })}
                              />
                              <Input
                                title={window.labels.checkout.fields.email}
                                type="email"
                                focus={Boolean(defaultValues.email)}
                                isError={Boolean(errors["email"])}
                                error={
                                  window.labels.checkout.errors["email"]?.[
                                    errors["email"]?.type
                                  ]
                                }
                                {...register("email", {
                                  ...validationRules["email"],
                                })}
                              />
                            </div>
                          </ModalContentBlock>
                          <ModalContentBlock
                            title={window.labels.e_certificate.delivery_data.title}
                            subtitle={window.labels.e_certificate.delivery_method_title}
                          >
                            <CommunicationMethod
                              onChange={(e) => {
                                setValue("delivery", e.target.value)
                              }}
                              showTitles
                              methods={[
                                {
                                  value: "viber",
                                  title: "Viber",
                                },

                                // {
                                //   value: "email",
                                //   title: "Email",
                                // },
                              ]}
                            />
                            <span className="divider" />
                            <Checkbox
                              title={window.labels.checkout.anotherRecipient}
                              {...register("another_recipient")}
                            />
                            {anotherRecipient && (
                              <div className="form-label-list">
                                <Input
                                  title={window.labels.checkout.fields.name}
                                  type="text"
                                  isError={Boolean(errors["recipient_name"])}
                                  error={
                                    window.labels.checkout.errors["name"]?.[
                                      errors["name"]?.type
                                    ]
                                  }
                                  {...register("recipient_name", {
                                    ...validationRules["default"],
                                  })}
                                  focus={getValues("recipient_name")}
                                />
                                <Input
                                  title={window.labels.checkout.fields.surname}
                                  type="text"
                                  isError={Boolean(errors["recipient_last_name"])}
                                  name="recipient_last_name"
                                  error={
                                    window.labels.checkout.errors["surname"]?.[
                                      errors["last_name"]?.type
                                    ]
                                  }
                                  {...register("recipient_last_name", {
                                    ...validationRules["default"],
                                  })}
                                  focus={getValues("recipient_last_name")}
                                />
                                <Input
                                  title={window.labels.checkout.fields.phone}
                                  type="tel"
                                  isError={Boolean(errors["recipient_phone"])}
                                  error={
                                    window.labels.checkout.errors["phone"]?.[
                                      errors["phone"]?.type
                                    ]
                                  }
                                  {...register("recipient_phone", {
                                    ...validationRules["phone"],
                                    // ...(deliveryMethod === "viber"
                                    //   ? validationRules["phone"]
                                    //   : {}),
                                  })}
                                  focus={getValues("recipient_phone")}
                                />
                                <Input
                                  title={window.labels.checkout.fields.email}
                                  type="email"
                                  isError={Boolean(errors["recipient_email"])}
                                  error={
                                    window.labels.checkout.errors["email"]?.[
                                      errors["email"]?.type
                                    ]
                                  }
                                  {...register("recipient_email", {
                                    ...validationRules["email"],
                                    // required: deliveryMethod === "email",
                                  })}
                                  focus={getValues("recipient_email")}
                                />
                                <InputDate
                                  // type="date"
                                  id="delivery_date_id"
                                  isError={Boolean(errors["delivery_date_only"])}
                                  title={window.labels.e_certificate.delivery_date_title}
                                  error={
                                    window.labels.e_certificate.errors["date"]?.[
                                      errors["delivery_date_only"]?.type
                                    ]
                                  }
                                  min={new Date().toISOString().split("T")[0]}
                                  max={
                                    new Date(
                                      new Date().setFullYear(
                                        new Date().getFullYear() + 1,
                                      ),
                                    )
                                      .toISOString()
                                      .split("T")[0]
                                  }
                                  note={window.labels.e_certificate.delivery_date_note}
                                  autoComplete="off"
                                  setValue={setValue}
                                  {...register("delivery_date_only", {
                                    required: true,
                                  })}
                                >
                                  <label htmlFor="delivery_date_only_full_id">
                                    <svg className="icon-calendar">
                                      <use href="#calendar" />
                                    </svg>
                                  </label>
                                </InputDate>

                                <InputTime
                                  type="text"
                                  isError={false}
                                  name="delivery_time"
                                  title={window.labels.e_certificate.delivery_time_title}
                                  error=""
                                  setValue={setValue}
                                  defaultValue={getValues("delivery_time")}
                                  required
                                />
                                {/* <InputTextarea
                                  title={
                                    window.labels.e_certificate.fields.delivery_message
                                  }
                                  note={
                                    window.labels.e_certificate.fields
                                      .delivery_messageDescription
                                  }
                                  name="delivery_message"
                                  {...register("delivery_message", {
                                    maxLength: 160,
                                  })}
                                  focus={getValues("delivery_message")}
                                /> */}
                              </div>
                            )}
                          </ModalContentBlock>
                          <ModalContentBlock
                            title={window.labels.e_certificate.payment_data.title}
                          >
                            <div className="pay-type">
                              {[
                                {
                                  code: "wayforpay",
                                  title:
                                    window.labels.e_certificate.payment_data
                                      .payment_methods["wayforpay"].title,
                                  description:
                                    window.labels.e_certificate.payment_data
                                      .payment_methods["wayforpay"].description,
                                },
                              ].map((p) => (
                                <div className="pay-type__item" key={p.code}>
                                  <label className="checkbox">
                                    <input
                                      type="radio"
                                      name="payment"
                                      value={p.code}
                                      // checked={p.code === paymentCode}
                                      className="container-input"
                                    />
                                    <span className="text">
                                      <div className="text__item">
                                        <div className="text-content">{p.title}</div>
                                        <div className="text-description">
                                          {p.description}
                                        </div>
                                      </div>
                                    </span>
                                    <span className="checkmark" />
                                  </label>
                                </div>
                              ))}
                            </div>
                          </ModalContentBlock>
                          <OrderComment
                            onChange={(e) => {
                              setValue("comment", e.target.value)
                            }}
                          />
                          <div
                            className={`order-head flex-s-b order__consent ${
                              errors.term_of_use_confirm ? "error" : ""
                            }`}
                          >
                            <label className="checkbox">
                              <input
                                name="term_of_use_confirm"
                                type="checkbox"
                                className="container-input"
                                {...register("term_of_use_confirm", {
                                  required: true,
                                  onChange: () => {
                                    trigger("term_of_use_confirm")
                                  },
                                })}
                              />
                              <span
                                className="text"
                                dangerouslySetInnerHTML={{
                                  __html: window.labels.checkout.fields.termOfUse,
                                }}
                              />
                              <span className="checkmark" />
                            </label>
                          </div>
                        </form>
                      </div>

                      {/* <Footer /> */}
                      <div className="row_btn">
                        <button
                          type="submit"
                          className="wb-btn btn-green"
                          form="cer_order_form"
                          disabled={isSubmitting}
                        >
                          {window.labels.checkout.likpayPay}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="modal-r-side">
                    <div className="certificate-total">
                      <div className="certificate-total__img-block">
                        <div className="certificate-img" />
                        {/* <img src="/images/certificates-page/uz-tape.png" alt="" /> */}
                      </div>
                      <div className="certificate-total__info body-b-14">
                        <div className="certificate-total__info-title">
                          {window.labels.e_certificate.certificate_title}
                        </div>
                        <div className="certificate-total__info-price">
                          {currencyFormatWithSign(toOrderValue)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Calendar */}
          <div className="date-calendar">
            <div className="calendar-holder">
              <div id="dateCalendar" />
              <div className="date-calendar__content">
                <div className="wb-btn btn-yellow save-calendar close-calendar">
                  <span>{window.labels.personal.general.apply}</span>
                </div>
                <div className="close-calendar">
                  {window.labels.personal.general.cancel}
                </div>
              </div>
            </div>
          </div>
          {/* /Calendar */}
        </>
      </CSSTransition>
      <CSSTransition
        in={isConfirmModalOpen}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
      >
        <Modal
          title={window.labels.popup.confirm_close.title}
          modalView="xs"
          cssModifyer="-mobile-bottom-sheet modal-confirm-close"
          onRequestClose={() => setIsConfirmModalOpen(false)}
        >
          <div className="form-content">
            <p className="body-r-14">
              <span>{window.labels.popup.confirm_close.text}</span>
            </p>
            <div className="row-btn">
              <button
                type="button"
                className="wb-btn btn-white"
                onClick={() => {
                  setIsConfirmModalOpen(false)
                  setIsSelfOpen(false)
                }}
              >
                <span>{window.labels.popup.confirm_close.confirm}</span>
              </button>
              <button
                type="button"
                className="wb-btn btn-green"
                onClick={() => {
                  setIsConfirmModalOpen(false)
                }}
              >
                <span>{window.labels.popup.confirm_close.cancel}</span>
              </button>
            </div>
          </div>
        </Modal>
      </CSSTransition>
    </>
  )
}
